import React, { useState } from 'react';
import { MemberModel, StudentExamModel, SiteSettingModel } from '../../../../models';
import { Trophy, Plus, BarChart3, List } from 'lucide-react';
import StudentExamList from './studentExamList';
import StudentExamReport from './studentExamReport';
import Header from '../studentFrame/header';

interface StudentExamRootProps {
    member: MemberModel;
    siteSettings: SiteSettingModel;
    onAdd: () => void;
    onEdit: (exam: StudentExamModel) => void;
}

type TabType = 'list' | 'report';

const StudentExamRoot: React.FC<StudentExamRootProps> = ({ member, siteSettings, onAdd, onEdit }) => {
    const [activeTab, setActiveTab] = useState<TabType>('list');

    const tabs = [
        { id: 'list' as TabType, label: '성적 목록', icon: List },
        { id: 'report' as TabType, label: '성적 분석', icon: BarChart3 },
    ];

    return (
        <div className="space-y-6 animate-in fade-in duration-500">
            {/* Header Section */}
            {/* Header Section */}
            <Header
                icon={Trophy}
                title="성적 기록"
                subtitle="나의 시험 성적을 기록하고 변화를 확인하세요."
                onButtonClick={onAdd}
                buttonText="새 성적 등록"
                buttonIcon={Plus}
            />

            {/* Tab Navigation */}
            <div className="flex gap-2 bg-white p-1.5 rounded-xl border border-slate-100 shadow-sm w-fit">
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-bold transition-all ${activeTab === tab.id
                            ? 'bg-indigo-600 text-white shadow-sm'
                            : 'text-slate-500 hover:text-slate-700 hover:bg-slate-50'
                            }`}
                    >
                        <tab.icon size={16} />
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Tab Content */}
            <div className="animate-in fade-in duration-300">
                {activeTab === 'list' ? (
                    <StudentExamList
                        member={member}
                        siteSettings={siteSettings}
                        onEdit={onEdit}
                    />
                ) : (
                    <StudentExamReport member={member} />
                )}
            </div>
        </div>
    );
};

export default StudentExamRoot;
